import React, { useEffect, createElement } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { HealthArticle } from './components/HealthArticle';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined') {
      ;
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // Safety check: if no script tags exist, append to head instead
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '2363576474060504');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <HelmetProvider data-id="element-0">
      <HealthArticle data-id="element-1" />
    </HelmetProvider>;
}